import { Injectable, HostListener } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class DeviceDetectorService {
  private readonly mobileSubject = new BehaviorSubject<boolean>(this.checkIfMobile());
  isMobile$ = this.mobileSubject.asObservable();

  constructor() {
    this.updateMobileStatus();
  }

  private checkIfMobile(): boolean {
    return window.innerWidth < 744;
  }

  @HostListener('window:resize', [])
  private updateMobileStatus(): void {
    this.mobileSubject.next(this.checkIfMobile());
  }
}
